module.exports = __webpack_public_path__ + "static/AndrewAskins-16f699da6d723ec063296096e03be28b.jpg";